import { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

// Custom hook to manage sponsorship data
export function useSponsorship() {
  const [sponsorships, setSponsorships] = useState(new Set());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSponsorships();
  }, []);

  async function loadSponsorships() {
    try {
      const sponsorshipSnapshot = await getDocs(collection(db, "sponsorships"));
      const sponsoredDancers = new Set();
      
      sponsorshipSnapshot.forEach((doc) => {
        const data = doc.data();
        if (data.sponsor === 'prima') {
          sponsoredDancers.add(doc.id); // Document ID is the dancer name
        }
      });
      
      setSponsorships(sponsoredDancers);
    } catch (error) {
      console.error('Error loading sponsorships:', error);
    } finally {
      setLoading(false);
    }
  }

  const isSponsored = (dancerName) => {
    return sponsorships.has(dancerName);
  };

  const refreshSponsorships = () => {
    setLoading(true);
    loadSponsorships();
  };

  return {
    isSponsored,
    loading,
    refreshSponsorships,
    sponsorships
  };
}
